let inFlight = 0
const listeners = new Set()

const notify = () => {
  listeners.forEach((fn) => {
    try {
      fn()
    } catch {
      // ignore
    }
  })
}

export function beginApiLoad() {
  inFlight += 1
  notify()
}

export function endApiLoad() {
  inFlight = Math.max(0, inFlight - 1)
  notify()
}

export function subscribeApiLoading(onStoreChange) {
  listeners.add(onStoreChange)
  return () => listeners.delete(onStoreChange)
}

export function getApiLoadingSnapshot() {
  return inFlight
}

export function getServerApiLoadingSnapshot() {
  return 0
}
